import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import DTAFooter from "@dta/components/DTAFooterComponents/DTAFooter";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_DTA_LABEL,
  EVENTS_AWARDS_DTA_PATH,
} from "@events-awards/utils/constants";
import {
  DTAStaticPageFactory,
  getStaticPageTitle,
} from "@events-awards/utils/helpers";
import { AwardType } from "@events-awards/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

type DTAStaticPageProps = {
  /** The url string to get url at DTA static page. */
  urlPath: string;
};

/**
 * Component to render DTA static navigation pages
 */
const DTAStaticPage = ({ urlPath }: DTAStaticPageProps): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  const StaticLayout = DTAStaticPageFactory(urlPath);

  return (
    <div className="w-full" data-testid="dta-static-page-component">
      <AdSettings
        adNames={["lb1", "prestitial", "catfish"]}
        path={EVENTS_AWARDS_DTA_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Design AI and Tech"
        chapter1="design ai and tech"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={getStaticPageTitle(urlPath) + "  - THE BUSINESS TIMES"}
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_DTA_LABEL} - Find ${EVENTS_AWARDS_DTA_LABEL} News & Headlines, insight and analysis in Singapore, ASBA-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_DTA_PATH}
      />

      <EventsAwardsHeader />

      <Container rootClassName="pb-8 w-full justify-center px-3 text-left text-gray-850">
        <EventsAwardsNavigationBar awardType={AwardType.DATA} />

        <>{StaticLayout ? <StaticLayout /> : null}</>
      </Container>

      <DTAFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default DTAStaticPage;
